import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const SliderCalculatorForAnnualRevenueContainer = styled.div`
  display: grid;
  border-radius: 16px;
  overflow: hidden;
  font-family: Mulish, Arial, sans-serif;
`;

export const SliderCalculatorInputsContainer = styled.div`
  display: grid;
  padding: 2.5rem 3.75rem 1rem;
  background-color: ${palette.white};

  @media all and (max-width: ${layout.md}) {
    padding: 2.5rem 1.5rem;
  }
`;

export const SliderCalculatorValueContainer = styled.div`
  position: relative;
  align-content: center;
  padding: 1rem 2rem;
  min-height: 150px;
  box-sizing: border-box;
  color: ${palette.white};
  background: radial-gradient(100% 35% at 50% 50%, rgba(0, 125, 125, 0.4) 0%, rgba(0, 73, 73, 0.4) 100%),
    ${palette.spruce};
`;

export const ValueBackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 0;
  mix-blend-mode: soft-light;
`;

export const AnnualRevenueValueBlock = styled.div`
  display: flex;
  flex-flow: column wrap;
  position: relative;
  z-index: 2;
  align-items: center;

  .annual-revenue-text {
    text-transform: uppercase;
    letter-spacing: 1.6px;
  }
`;

